<style lang="scss" scoped>
.message-btns {
  display: flex;
  // width: 80%;
  margin: 0 auto;
  padding-bottom: .14rem;
  .weak {
    @include button();
    margin-left: .15rem;
    margin-right: .15rem;
  }
  .focus {
    @include buttonBright();
    margin-right: .15rem;
    margin-left: .15rem;
  }
  .button {
    width: .80rem;
    height: .30rem;
    line-height: .30rem;
  }
  &.is-feedbacked .button{
    cursor: not-allowed;
  }
}
.message-result {
  font-size: .12rem;
  line-height: 1.5em;
  color: #333333;
  text-align: center;
  padding-bottom: .14rem;
}
</style>

<template>
  <div class="component-root">
    <!-- 业务推荐 -->
    <div class="message-header">
      <em class="icon-dot"></em>以上答案是否对您有帮助
    </div>
    <div class="message-btns" :class="{ 'is-feedbacked': isFeedBacked }">
      <button
        class="button focus"
        @click="feedbackHelpful(1)"
      >有帮助</button>
      <button
        class="button weak"
        @click="feedbackHelpful(2)"
      >无帮助</button>
    </div>
    <div
      class="message-result"
      v-show="isFeedBacked"
    >
      {{ isFeedBacked === 1 ? '感谢您的认可，我会继续加油。' : '抱歉！没有能够帮到您，我们会持续改进。' }}
    </div>
  </div>
</template>

<script>
import { feedback } from '@/api/chat'
export default {
  name: 'BubbleFeedback',
  props: {
    message: Object
  },
  data () {
    return {
      isFeedBacked: false
    }
  },
  methods: {
    async feedbackHelpful (useful) {
      // 反馈 过的不再反馈
      if (this.isFeedBacked) {
        return false
      }
      try {
        await feedback({
          applyId: this.message.applyId,
          useful
        })
        this.isFeedBacked = useful
        this.$store.commit('updateFreshNeed', true)
      } catch (e) {
        this.isFeedBacked = false
      }
    }
  }
}
</script>
